import { COHORT_FIREBASE_KEYS_MAP } from 'nove8/constants/ab-tests'
import { useEffect } from 'react'
import { useShallow } from 'zustand/shallow'
import { useZustandStore } from 'zustandGlobalStore'
import { getRemoteConfigVariantData } from '../helpers/getRemoteConfigVariantData'

export const useGetRemoteConfigVariantData = (): void => {
  const { cohort, firebaseRemoteConfig } = useZustandStore(
    useShallow((state) => ({
      cohort: state.lead?.cohort || state.initialCohort,
      firebaseRemoteConfig: state.firebaseRemoteConfig,
    })),
  )

  useEffect(() => {
    const remoteConfigVariantValue = getRemoteConfigVariantData({
      firebaseRemoteConfig,
      firebaseRemoteConfigKey: COHORT_FIREBASE_KEYS_MAP[cohort],
    })

    useZustandStore.setState({
      firebaseRemoteConfigVariantData: remoteConfigVariantValue,
    })
  }, [firebaseRemoteConfig, cohort])
}
